import { render, staticRenderFns } from "./hdqList.vue?vue&type=template&id=36f0e6fe&scoped=true"
import script from "./hdqList.vue?vue&type=script&lang=js"
export * from "./hdqList.vue?vue&type=script&lang=js"
import style0 from "./hdqList.vue?vue&type=style&index=0&id=36f0e6fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f0e6fe",
  null
  
)

export default component.exports